import axios from 'axios';

const api = axios.create({
  baseURL: "https://admin-service.swasthyakhata.com/admin/api/"
});

export default api;